/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PopupDto } from '../../models/popup-dto';

export interface PopupAdminControllerDeleteV1$Params {
  id: string;
}

export function popupAdminControllerDeleteV1(http: HttpClient, rootUrl: string, params: PopupAdminControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PopupDto>> {
  const rb = new RequestBuilder(rootUrl, popupAdminControllerDeleteV1.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PopupDto>;
    })
  );
}

popupAdminControllerDeleteV1.PATH = '/api/v1/popups/admin/{id}';
